import { render, staticRenderFns } from "./TemplateC.vue?vue&type=template&id=720db508&scoped=true&"
import script from "./TemplateC.vue?vue&type=script&lang=js&"
export * from "./TemplateC.vue?vue&type=script&lang=js&"
import style0 from "./TemplateC.vue?vue&type=style&index=0&id=720db508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720db508",
  null
  
)

export default component.exports